import {accountingTypes} from 'helpers/constants'
import {isEmpty} from 'lodash'
import {sortByLabel} from 'helpers/sorting'
import {XeroParent, xeroSalesParents} from './integrations/xero'
import {quickBooksPurchasingParents, quickBooksSalesParents} from './integrations/quickBooks'
import {isValueValid} from "helpers/accounting"

export const filterToSalesNominalCodes = (nominalCodes, accountsIntegration) => {
  switch (accountsIntegration.id) {
    case accountingTypes.XERO.id:
      return nominalCodes.filter(code => xeroSalesParents.includes(code.parent))
    case accountingTypes.QUICK_BOOKS_ONLINE.id:
      return nominalCodes.filter(code => quickBooksSalesParents.includes(code.parent))
    default:
      return nominalCodes
  }
}

export const filterToPurchaseNominalCodes = (nominalCodes, accountsIntegration) => {
  switch (accountsIntegration.id) {
    case accountingTypes.XERO.id:
      return nominalCodes.filter(code => !xeroSalesParents.includes(code.parent))
    case accountingTypes.QUICK_BOOKS_ONLINE.id:
      return nominalCodes.filter(code => quickBooksPurchasingParents.includes(code.parent))
    default:
      return nominalCodes
  }
}

export const getNominalCodeOption = (nominalCode) => ({
  key: nominalCode.code,
  label: nominalCode.code && nominalCode.code.length ? `${nominalCode.code}: ${nominalCode.desc}` : nominalCode.desc,
  desc: nominalCode.desc,
  value: nominalCode.code,
  nominalCode,
})

export const getNominalCodeOptions = (nominalCodes, value) => {
  const options = nominalCodes.map(getNominalCodeOption)

  if (!isValueValid(value, options)) {
    options.push({
      key: value + ' Invalid',
      label: value + ' Invalid',
      value: value,
    })
  }

  return options.sort((a, b) => sortByLabel(a, b))
}

export const getNominalCodeGroupName = (group) => {
  switch (group) {
    case XeroParent.OTHER_INCOME:
      return 'OTHER INCOME'
    case XeroParent.DIRECT_COSTS:
      return 'DIRECT COSTS'
    default:
      return group.replace(/_/g, ' ')
  }
}

export const getNoNominalCodesPlaceholder = (nominalCodes) => {
  return isEmpty(nominalCodes)
      ? 'Accounting System Not Connected'
      : 'Not Specified'
}
